"use client";

import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CircleCheck, Shield, Users, Clock, Lock, Headphones } from "lucide-react";
export default function OurServices() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const services = [{
    icon: CircleCheck,
    title: "Full-Service Property Management",
    description: "Comprehensive oversight of all property operations, maintenance, and vendor coordination to ensure seamless estate performance.",
    delay: "0ms"
  }, {
    icon: Shield,
    title: "Estate Oversight",
    description: "Meticulous monitoring and strategic planning for long-term property value preservation and enhancement.",
    delay: "100ms"
  }, {
    icon: Users,
    title: "Concierge Coordination",
    description: "White-glove concierge services tailored to your lifestyle, handling everything from daily tasks to special requests.",
    delay: "200ms"
  }, {
    icon: Clock,
    title: "Estate Operations",
    description: "End-to-end management of household staff, scheduling, and operational logistics for flawless daily execution.",
    delay: "300ms"
  }, {
    icon: Lock,
    title: "Security and Maintenance",
    description: "Proactive security assessments and preventive maintenance programs ensuring peace of mind and property integrity.",
    delay: "400ms"
  }, {
    icon: Headphones,
    title: "Discreet Client Support",
    description: "Confidential, personalized service delivered with the utmost discretion and respect for your privacy.",
    delay: "500ms"
  }];
  return <section id="our-services" className="py-24 px-6 bg-background" ref={containerRef}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-semibold text-foreground mb-4">
            Our Services
          </h2>
          <p className="text-lg max-w-2xl mx-auto !text-[hsl(0,0%,100%)]">
            Tailored property management solutions designed for discerning clients who demand excellence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className={`card transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: isVisible ? service.delay : "0ms"
          }}>
                <CardHeader>
                  <div className="mb-4">
                    <Icon className="w-10 h-10 text-primary stroke-[1.5]" />
                  </div>
                  <CardTitle className="text-xl mb-2">{service.title}</CardTitle>
                  <CardDescription className="text-base leading-relaxed !text-[hsl(0,0%,100%)]">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <Link to="#" className="inline-flex items-center text-primary font-semibold hover:text-primary-hover group transition-colors duration-[var(--duration-fast)]">
                    Learn More
                    <span className="ml-2 inline-block transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1">
                      →
                    </span>
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-[var(--duration-medium)]"></span>
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}